import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  filterTypeControl: {
    marginLeft: spacing(2)
  },
  filterTypeSelect: {
    display: 'flex',
    alignItems: 'center',
    width: 170
  }
}))
